module.exports = __webpack_public_path__ + "static/img/pattern.90e8d182.png";